import { useSelector } from 'react-redux';
import { PortalConfigurationRolesSettingsKeys } from 'types';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

export function usePortalConfigurationChecks() {
  const role = useSelector<any, string>(state => state.userProfile.vendorContactRole);
  const portalConfigurationData = useSelector(portalConfigurationsSelectors.configData);

  const checkPortalConfigEntryForCurrentUserRole = (
    type: PortalConfigurationType,
    key: PortalConfigurationRolesSettingsKeys
  ) => {
    const portalConfiguration = portalConfigurationData?.[type];
    const rolesSettings = portalConfiguration?.jsonDefinition?.config.rolesSettings?.[key];

    return !!rolesSettings?.includes(role);
  };

  const checkAftermarketPartnerAllowSendProposals = (): boolean => {
    const portalConfiguration = portalConfigurationData?.[PortalConfigurationType.Aftermarket];
    return !!portalConfiguration?.jsonDefinition?.config?.partnerAllowSendProposals;
  };

  return {
    checkPortalConfigEntryForCurrentUserRole,
    checkAftermarketPartnerAllowSendProposals,
  };
}
